import { actionCopyDa } from "./actionCopy";

export const authCopyDa = {
    backToWebsite: "Tilbage til hjemmesiden",
    languageLabel: "Language / Sprache / Sprog / Langue",
    languageDescription:
        "Change the app language. Sprache der App ändern. Skift appens sprog. Changer la langue de l'application.",
    chooseLanguage: "Vælg sprog",
    or: "ELLER",
    next: actionCopyDa.next,
    submit: actionCopyDa.submit,
    continue: actionCopyDa.continue,
    logout: "Log ud",
    verifyingAuthentication: "Bekræfter godkendelse...",
    signUpSignIn: "Opret konto / Log ind",
    signIn: "Log ind",
    signUp: "Opret konto",
    signUpWith: (name: string) => `Opret konto med ${name}`,
    joinStudy: (studyName) => `Deltag i ${studyName}`,
    alreadyHaveAccount: "Har du allerede en konto?",
    dontHaveAccount: "Har du ikke en konto?",
    signInWithPasswordInstead: "Log ind med adgangskode i stedet",
    contactMethodLabel: "Kontaktmetode",
    patientRole: "Patient",
    forgotPassword: "Glemt adgangskode",
    confirmYourAccount: "Bekræft din konto",
    choosePassword: "Vælg adgangskode",
    confirmPassword: "Bekræft adgangskode",
    showPassword: "Vis adgangskode",
    passwordsDontMatch: "Adgangskoderne stemmer ikke overens",
    passwordsMatch: "Adgangskoderne stemmer overens",
    passwordAllGood: "Alt i orden!",
    passwordRequirementMinLength: "Skal være mindst 8 tegn langt",
    passwordRequirementLowercase: "Skal indeholde et lille bogstav",
    passwordRequirementUppercase: "Skal indeholde et stort bogstav",
    passwordRequirementNumber: "Skal indeholde et tal",
    passwordRequirementSpecial: "Skal indeholde et specialtegn",
    setYourPassword: "Angiv din adgangskode",
    setPasswordDescription: "Opret en sikker adgangskode til din konto",
    settingPassword: "Angiver adgangskode...",
    smartAuthHint: "Angiv den e-mailadresse eller det telefonnummer, din Patient Watch-invitation blev sendt til.",
    usePhoneInstead: "Brug telefon i stedet",
    useEmailInstead: "Brug e-mail i stedet",
    phoneVerificationHint: "Vi sender en bekræftelseskode til din telefon.",
    phoneSignupHint: "Vi sender en bekræftelseskode til din telefon. Standardtakster for SMS kan gælde.",
    loggingIn: "Logger ind...",
    sendingCode: "Sender kode...",
    logIn: "Log ind",
    sendCode: "Send kode",
    sendVerificationCode: "Send bekræftelseskode",
    sendingCodeEllipsis: "Sender kode...",
    codeSent: "Kode sendt",
    codeSentToPhone: "Kode sendt til din telefon",
    verificationCodeSent: "Bekræftelseskode sendt",
    emailFallbackCodeSent: "Vi kunne ikke sende en SMS, så vi har i stedet sendt dig en kode via e-mail.",
    checkFormAndTryAgain: "Kontrollér formularen og prøv igen.",
    somethingWentWrong: "Noget gik galt. Prøv igen.",
    newUser: "Ny bruger",
    invitationFound: "Invitation fundet",
    accountFound: "Konto fundet",
    accountFoundUseEmailSmsNotReady:
        "Konto fundet. Log ind med din e-mail. SMS-login er endnu ikke opsat for dette nummer på din konto.",
    smsLoginContactCareTeam:
        "SMS-login er ikke tilgængeligt for dette nummer. Kontakt venligst teamet, der inviterede dig.",
    authMethodError: "Godkendelsesfejl",
    smsLoginUnavailable:
        "SMS-login er endnu ikke tilgængeligt for dette nummer. Log ind med e-mailadressen på din konto i stedet.",
    email: "E-mail",
    emailTab: "E-mail",
    phoneTab: "Telefon",
    emailPlaceholder: "f.eks. navn@firma.dk",
    password: "Adgangskode",
    phone: "Telefonnummer",
    enterEmailAddress: "Angiv din e-mailadresse",
    enterPhoneNumber: "Angiv dit telefonnummer",
    enterPhoneWithCountryCode: "Angiv et telefonnummer inkl. landekode.",
    forgotPasswordEmailHint:
        "Angiv e-mailadressen på din konto. Vi sender dig en bekræftelseskode til at nulstille din adgangskode.",
    forgotPasswordPhoneHint: "Angiv telefonnummeret på din konto. Vi sender en bekræftelseskode via SMS.",
    sending: "Sender...",
    backToSignIn: "Tilbage til log ind",
    backToForgotPassword: "Tilbage til glemt adgangskode",
    backToConfirmAccount: "Tilbage til kontobekræftelse",
    backToSignup: "Tilbage til opret konto",
    verifyYourAccount: "Bekræft din konto",
    verifyEmailCodeHint: "Angiv den bekræftelseskode, der er sendt til din e-mailadresse.",
    verifySmsCodeHint: "Angiv koden, der er sendt til dit telefonnummer.",
    verifying: "Bekræfter...",
    resendCode: "Send kode igen",
    didNotReceiveCode: "Modtog du ikke en kode?",
    resendConfirmationCode: "Send bekræftelseskode igen",
    needHelpContact: "Brug for hjælp? Kontakt",
    consentTermsPrefix: "Jeg accepterer",
    termsOfUse: "Brugsbetingelserne",
    consentAnd: "og",
    privacyPolicy: "Privatlivspolitikken",
    selectHospitalLabel: "På hvilket hospital er du i behandling?",
    selectHospitalPlaceholder: "Vælg dit hospital",
    selectHospitalToContinue: "Vælg venligst dit hospital for at fortsætte.",
    ownOrganisationNameLabel: "Organisationsnavn",
    ownOrganisationNamePlaceholder: "f.eks. Byens ortopædklinik",
    ownOrganisationNameHint: "Dette opretter din organisation på Patient Watch. Du kan invitere kolleger senere.",
    organisationNameTooShort: "Angiv venligst et organisationsnavn med mindst 3 tegn.",
    signupSessionExpired: "Din oprettelsessession er udløbet. Gå tilbage og anmod om en ny kode.",
    loadingSignup: "Indlæser oprettelse...",
    welcomeToPatientWatch: "Velkommen til Patient Watch",
    invitedByLine: (name: string) => `${name} har inviteret dig til at tilmelde dig Patient Watch.`,
    welcomeFirstTime: "Velkommen - det ser ud til, at det er din første gang her.",
    choosePasswordDescription: "Vælg en adgangskode for at afslutte opsætningen af din konto.",
    alreadyHavePasswordSkip: "Spring over - jeg har allerede en adgangskode",
    finishProfileSetup: "Lad os afslutte opsætningen af din profil.",
    continueToProfileSetup: "Fortsæt til profilopsætning",
    alreadySignedIn: "Allerede logget ind",
    alreadySignedInDescription:
        "Fortsæt til appen, eller log ud, hvis du har brug for en anden konto (f.eks. for at åbne en invitation eller et tilmeldingslink, mens du allerede er logget ind).",
    continueToProfile: "Fortsæt",
    continueToApp: "Fortsæt",
    notLoggedInResetPassword: "Du er ikke logget ind. For at nulstille din adgangskode, gå til:",
    authenticationComplete: "Godkendelse gennemført",
    authenticationCompleteDescription: "Du er nu logget ind, klik på næste for at fortsætte.",
    authenticationFailed: "Godkendelse mislykkedes",
    authenticationFailedDescription: "Ugyldigt link, prøv igen.",
    noAccountFound: "Ingen konto fundet",
    noAccountForContact: (contact: string) => `Ingen konto for ${contact}`,
    noAccountForDetails: "Vi kunne ikke finde en konto med disse oplysninger.",
    inviteOnlyPlatform:
        "Patient Watch er en platform, der kun er åben for inviterede. Vælg din rolle for at fortsætte:",
    iAmPatient: "Jeg er patient",
    iAmClinician: "Jeg er kliniker",
    wrongEmailGoBack: "Tastet den forkerte e-mailadresse?",
    goBackAndTryAgain: "Gå tilbage og prøv igen.",
    noAccountChoosePath:
        "Hvis du er kliniker, kan du starte gratis med det samme. Hvis du er patient, skal du have en invitation.",
    noAccountPatientTitle: "Patienter",
    noAccountPatientDescription:
        "Patient Watch er kun åben for inviterede patienter. Bed din klinik om at invitere dig, eller få hjælp hvis du tror, du allerede har en invitation.",
    noAccountPatientCta: "Jeg har brug for patienthjælp",
    noAccountClinicianTitle: "Klinikere",
    noAccountClinicianDescription:
        "Invitér patienter, indsaml resultatmål og se fremskridt over tid - gratis at starte, intet kort nødvendigt. Opgrader først, når din patientmængde vokser.",
    noAccountClinicianCta: "Opret gratis konto",
    confirmAccountInviteTitle: "Du er inviteret til at tilmelde dig Patient Watch",
    couldNotVerifyContact: "Vi kunne ikke bekræfte dine kontaktoplysninger",
    invitedToJoin: "Du er inviteret til at tilmelde dig Patient Watch",
    inviterInvitedYou: (name: string) => `${name} har inviteret dig.`,
    confirmPhoneInviteBody:
        "Bekræft dit telefonnummer nedenfor. Vi sender dig en bekræftelseskode via SMS, så du kan afslutte opsætningen af din konto.",
    confirmEmailInviteBody:
        "Bekræft din e-mailadresse nedenfor. Vi sender dig en bekræftelseskode, så du kan afslutte opsætningen af din konto.",
    useInvitationContactDetails: "Brug dine invitationskontaktoplysninger",
    enterInvitationContactHint:
        "Angiv den e-mailadresse eller det telefonnummer, din Patient Watch-invitation blev sendt til.",
    enterConfirmationCode: "Angiv bekræftelseskode",
    processing: "Behandler",
    verifyYourEmailTitle: "Bekræft din e-mail",
    verifyEmailIcon: "Bekræft din e-mail",
    emailConfirmed: "E-mail bekræftet",
    emailConfirmedDescription: "Du kan nu fortsætte til log ind.",
    verifyEmailWelcome: (firstName?: string) =>
        `Velkommen${firstName ? `, ${firstName}` : ""}! Vi skal bekræfte din e-mailadresse.`,
    verifyEmailSendHint: "Vi sender en 6-cifret bekræftelseskode til denne e-mailadresse.",
    sendingCodeButton: "Sender kode...",
    sendVerificationCodeButton: "Send bekræftelseskode",
    enterVerificationCode: "Angiv bekræftelseskode",
    enterCodeSentTo: (email: string) => `Angiv venligst koden sendt til ${email}`,
    checkJunkFolder: "Glem ikke at tjekke din spam-mappe!",
    deleteAccount: "Slet konto",
    deleteAccountReason: "Årsag til sletning af konto",
    troubleAccessingTitle: "Problemer med at tilgå Patient Watch?",
    patientInviteMismatch: (email: string) =>
        `Hvis du har modtaget en invitation, skal du kontrollere, at den inviterede e-mailadresse er den samme som ${email}.`,
    patientContactProvider:
        "Hvis du mener at have modtaget en invitation, bedes du kontakte din behandler for at bekræfte dine oplysninger.",
    contactSupportTeam: "Kontakt vores supportteam",
    interestedInPwTitle: "Interesseret i Patient Watch?",
    interestedInPwBody1: "Følg patientresultater, og hold kontakten med din praksis.",
    signupStarterPlan: "Se betalte planer",
    carePlanInjection: "Din behandlingsplan inkluderer en injektion.",
    carePlanInjectionTo: (where: string, substance: string, amount: string) => {
        if (where && substance && amount) return `Injektion til ${where}: ${substance} (${amount}).`;
        if (where && substance) return `Injektion til ${where}: ${substance}.`;
        if (where && amount) return `Injektion til ${where} (${amount}).`;
        if (where) return `Opfølgning efter en injektion til ${where}.`;
        if (substance && amount) return `Injektion: ${substance} (${amount}).`;
        if (substance) return `Injektion: ${substance}.`;
        return "";
    },
    carePlanSurgery: "Din behandlingsplan inkluderer en operation.",
    carePlanSurgeryArea: (area: string) => `Din behandlingsplan inkluderer en operation (${area}).`,
    carePlanShockwave: "Din behandlingsplan inkluderer stødbehandling.",
    authErrorTitle: "Godkendelsesfejl",
    linkExpiredTitle: "Dette link er udløbet",
    almostThere: "Næsten færdig!",
    preparingAccount: "Et øjeblik, vi forbereder din konto...",
    verifyEmailCallBody: (email: string) =>
        `Angiv venligst koden sendt til ${email}.\n\nGlem ikke at tjekke din spam-mappe!`,
    verifyingPhone: "Bekræfter telefonnummer",
    verifyingEmail: "Bekræfter e-mail",
    phoneVerified: "Telefon bekræftet",
    emailVerified: "E-mail bekræftet",
    verifyingPhoneWait: "Et øjeblik, vi bekræfter dit telefonnummer...",
    verifyingEmailWait: "Et øjeblik, vi bekræfter din e-mail...",
    phoneVerifiedSuccess: "Dit telefonnummer er bekræftet! Lad os opsætte din konto.",
    emailVerifiedSuccess: "Din e-mailadresse er bekræftet! Lad os opsætte din konto.",
    verifyPhoneError: "Prøv at bekræfte dit telefonnummer igen, eller kontakt support@patient-watch.com",
    verifyEmailError: "Prøv at bekræfte din e-mail igen, eller kontakt support@patient-watch.com",
    verificationError: "Bekræftelsesfejl",
    tryAgain: "Prøv igen",
    freemiumSignupTitle: "Opret din gratis konto",
    freemiumSignupDescription:
        "Invitér patienter, indsaml resultatmål og følg deres bedring - klar på få minutter, intet kort nødvendigt.",
    freemiumSignupBenefit1: "Invitér patienter og indsaml resultatmål med det samme",
    freemiumSignupBenefit2: "Automatiske påmindelser holder patienterne engagerede mellem besøg",
    freemiumSignupBenefit3: "Se fremskridt over tid i et klart klinikerdashboard",
    freemiumSignupCta: "Opret gratis konto",
    freemiumSignupSubmitting: "Opretter konto…",
    freemiumSignupUpgradeHint: "Har du brug for større volumen?",
    freemiumSignupSeePaidPlans: "Se andre planer",
    diaryInviteUnavailableTitle: "Denne invitation er ikke tilgængelig",
    diaryInviteUnavailableCallout: "Ingen dagbog blev startet",
    diaryInviteUnavailableBody: "Der kan ikke tilføjes endnu en dagbog på den nuværende plan.",
    diaryInviteUnavailableNextStep: "Kontakt venligst din klinik. De kan invitere dig igen, når de har kapacitet.",
    diaryInviteOwnerUnresolvedBody: "Vi kunne ikke starte denne dagbog. Bed om et nyt invitationslink.",
    mfaEnrollTitle: "Opsæt godkendelsesapp",
    mfaEnrollDescription: "Scan QR-koden, og indtast derefter den sekscifrede kode fra din app.",
    mfaManualSetup: "Kan du ikke scanne QR-koden?",
    mfaQrCodeAlt: "QR-kode til opsætning af autentificeringsapp",
    mfaChallengeTitle: "Totrinsgodkendelse",
    mfaChallengeDescription: "Indtast den sekscifrede kode fra din godkendelsesapp.",
    mfaAuthenticatorCode: "Godkendelseskode",
    mfaVerifyCode: "Bekræft kode",
    mfaVerifying: "Bekræfter…",
    mfaLoading: "Indlæser…",
    mfaSettingsTitle: "Godkendelsesapp-sikkerhed",
    mfaSettingsDescription: "Din godkendelsesapp er påkrævet for privilegeret adgang.",
    mfaFactorActive: "Godkendelsesapp aktiv",
    mfaReplaceFactor: "Udskift godkendelsesapp",
    mfaReplaceConfirm: "Fjern denne godkendelsesapp og opsæt en ny nu?",
};
